import React from 'react';
import PropTypes from 'prop-types';
import {
  FDPrimaryActionButton,
} from '@facet-wealth/design';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { relationshipType } from 'facet-rest/src/consts/relationships';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { dataAttrs } from 'Helpers/Testing';


const EstatePlanningProfileSubpageStepAction = ({
  relationship,
}) => {
  const { loadPageContentLink } = usePageContentContext();
  const { loadModalCollectionByLink } = useModalContext();
  const { displayErrorMessage } = useSnackbarContext();

  const handleOnClick = () => {
    // switch on meta type to open as hyperlink or as modal
    const type = relationship.meta('type');
    const link = relationship.link('related');
    const url = link.url();
    let err;
    switch (type) {
      case relationshipType.pagelink:
        loadPageContentLink(link);
        break;
      case relationshipType.modalLink:
        loadModalCollectionByLink(url);
        break;
      case relationshipType.hyperlink:
        window.open(url, '_blank');
        break;
      default:
        err = new Error('Unknown action for estate planning profile step action.');
        displayErrorMessage(err);
    }
  };

  return (
    <FDPrimaryActionButton
      label={relationship.meta('prompt')}
      onClick={() => handleOnClick()}
      flexShrink={0}
      {...dataAttrs('estate-planning-action-btn')}
    />
  );
};

EstatePlanningProfileSubpageStepAction.propTypes = {
  relationship: PropTypes.object.isRequired,
};

export default EstatePlanningProfileSubpageStepAction;
